var map = {
	"./pages/authentication/forgot-password/forgot-password.module": [
		"./src/app/pages/authentication/forgot-password/forgot-password.module.ts",
		"pages-authentication-forgot-password-forgot-password-module"
	],
	"./pages/authentication/login/login.module": [
		"./src/app/pages/authentication/login/login.module.ts",
		"pages-authentication-login-login-module"
	],
	"./pages/authentication/register/register.module": [
		"./src/app/pages/authentication/register/register.module.ts",
		"pages-authentication-register-register-module"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"pages-dashboard-dashboard-module"
	],
	"./pages/statclient/statclient.module": [
		"./src/app/pages/statclient/statclient.module.ts"
	],
	"./pages/statforclient/statforclient.module": [
		"./src/app/pages/statforclient/statforclient.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;